import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useGetUser } from '../../context/userContext';

const Circle = () => {
  const user = useGetUser();

  const userCopy = { ...user };
  delete userCopy._id;
  delete userCopy.createdAt;
  delete userCopy.__v;
  delete userCopy.birthDate;

  const values = Object.values(userCopy);
  const filteredValues = values.filter((el) => {
    if (el === '' || el?.length === 0) return false;
    return true;
  });

  const percentage = Math.floor((100 * filteredValues?.length) / 19);

  return (
    <>
      <p className="lead text-center">Profile completion</p>
      <div style={{ width: '125px', margin: '0 auto' }}>
        <CircularProgressbar value={percentage} text={`${percentage}%`} />
      </div>
    </>
  );
};

export default Circle;
